import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";
import Badge from "@/components/ui/badge";
import { useNotificationData } from "@/contexts/NotificationsProvider";
import NotificationDropdown from "@/components/navbar/notifications/NotificationDropdown";

function NotificationBellReady() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const {
    notifications,
    unreadNotifications,
    initialLoading,
    getStatus,
    markRead,
    markAllRead,
    requestClassification,
  } = useNotificationData();

  return (
    <Popover
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        // Defer the decision fetch until the dropdown actually opens.
        if (next) requestClassification();
      }}
    >
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label="Notifications"
          className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-text-secondary outline-none transition-colors hover:bg-surface-muted focus-visible:ring-4 focus-visible:ring-primary/15"
        >
          <Bell size={18} />
          {unreadNotifications.length > 0 && (
            <Badge
              count={unreadNotifications.length}
              className="absolute right-0 top-0"
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={8}
        className="w-[392px] overflow-hidden rounded-2xl border border-border-default bg-white shadow-dialog"
      >
        <NotificationDropdown
          notifications={notifications}
          initialLoading={initialLoading}
          getStatus={getStatus}
          onMarkRead={markRead}
          onMarkAllRead={markAllRead}
          onViewAll={() => {
            setOpen(false);
            navigate("/notifications");
          }}
        />
      </PopoverContent>
    </Popover>
  );
}

export default NotificationBellReady;
